import { cn } from '@arqam/ui'
import { useId } from 'react'
import { useTranslation } from 'react-i18next'

import { useTheme, type ThemeChoice } from '../lib/theme.js'

const CHOICES: readonly ThemeChoice[] = ['system', 'light', 'dark']

/** System / light / dark as a radio group; the choice is stored per browser. */
export function ThemeSwitch({ className }: { className?: string }) {
  const { t } = useTranslation()
  const { choice, setChoice } = useTheme()
  // Native radio groups are document-wide per name; two switches (rail and settings page) need
  // their own group each.
  const group = useId()
  return (
    <fieldset className={cn('m-0 flex flex-col gap-2 border-0 p-0', className)}>
      <legend className="mb-2 text-sm font-semibold text-muted">{t('theme.label')}</legend>
      <div className="grid grid-cols-3 gap-1 rounded-[14px] border border-line bg-surface p-1">
        {CHOICES.map(value => (
          <label
            key={value}
            className={cn(
              'flex min-h-11 cursor-pointer items-center justify-center rounded-[10px] px-2 text-sm font-semibold has-[:focus-visible]:outline-2 has-[:focus-visible]:outline-focus',
              choice === value ? 'bg-raised text-on-raised' : 'text-muted hover:text-text'
            )}
          >
            <input
              type="radio"
              name={group}
              value={value}
              checked={choice === value}
              onChange={() => {
                setChoice(value)
              }}
              className="sr-only"
            />
            {t(`theme.${value}`)}
          </label>
        ))}
      </div>
    </fieldset>
  )
}
